import {NgModule} from '@angular/core';
import {CommonMaterialModule} from './common-material.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ChallengeInlineDialogModule } from './challenge-inline-dialog/challenge-inline-dialog.module';


@NgModule({
  imports: [
    CommonMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    ChallengeInlineDialogModule,
  ],
  exports: [
    CommonMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    ChallengeInlineDialogModule
  ]
})
export class SharedModule {

}
